import { makeAutoObservable } from 'mobx';
import { Location } from 'react-router-dom';

export class NavigationStore {
  private navigate: (to: string) => void;
  private _location: Location | undefined;

  constructor() {
    makeAutoObservable(this);
    this.navigate = () => {
      throw new Error('Navigate function is not initialized');
    };
  }

  setNavigateFunction(navigateFn: (to: string) => void, location: Location) {
    this.navigate = navigateFn;
    this._location = location;
  }

  goToPage(path: string) {
    this.navigate(path);
  }

  get location() {
    return this._location;
  }
}

const navigationStore = new NavigationStore();
export default navigationStore;
